import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import TextField from "material-ui/TextField"
import { green500 } from "material-ui/styles/colors"

const lowerCaseRegEx = new RegExp(("^(?=.*[a-z]).+$"))
const upperCaseRegEx = new RegExp(("^(?=.*[A-Z]).+$"))
const numberRegEx = new RegExp(("^(?=.*\\d).+$"))
const specialCharacterRegEx = new RegExp(("^(?=.*[-+_!@#$%^&*.,?]).+$"))

interface IProps {
    password: string
    errorPassword?: string
    disabled?: boolean
    handleChange(password: string, valid: boolean): void
    handleSave(password: string, valid: boolean): void
    autoComplete?:string
}
interface IState {
    password: string
    eightCharactersLong: boolean
    oneLowerCase: boolean
    oneUpperCase: boolean
    oneNumberOrSymbol: boolean
}

export default class PasswordField extends React.Component<IProps, IState> {
    constructor(props, context) {
        super(props, context)
        this.state = {
            password: "",
            eightCharactersLong: false,
            oneLowerCase: false,
            oneUpperCase: false,
            oneNumberOrSymbol: false
        }
        autobind(this)
    }

    verifyPassword() {
        let eightCharactersLong = false
        let oneLowerCase = false
        let oneUpperCase = false
        let oneNumberOrSymbol = false

        if (this.state.password.length >= 8) {
            eightCharactersLong = true
        }

        if (lowerCaseRegEx.test(this.state.password)) {
            oneLowerCase = true
        }

        if (upperCaseRegEx.test(this.state.password)) {
            oneUpperCase = true
        }

        if (numberRegEx.test(this.state.password) || specialCharacterRegEx.test(this.state.password)) {
            oneNumberOrSymbol = true
        }

        this.setState({
            eightCharactersLong: eightCharactersLong,
            oneLowerCase: oneLowerCase,
            oneUpperCase: oneUpperCase,
            oneNumberOrSymbol: oneNumberOrSymbol
        })
        return eightCharactersLong && oneLowerCase && oneUpperCase && oneNumberOrSymbol
    }

    render() {
        return (
            <div style={{ textAlign: "left" }}>
                <TextField
                    autoFocus
                    floatingLabelText={strings.Password}
                    value={this.state.password}
                    errorText={this.props.errorPassword}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                    type="password"
                    onChange={e => this.setState({ password: e.target.value }, () => this.props.handleChange(this.state.password, this.verifyPassword()))}
                    onKeyUp={event => event.keyCode === 13 && this.props.handleSave(this.state.password, this.verifyPassword())}
                    style={{ marginRight: 20, width: "100%", position: "relative", fontSize: 20 }}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autoComplete}
                />
                <div style={{ fontSize: 12, marginTop: 13, lineHeight: "15px" }}>
                    <div style={{ color: this.state.eightCharactersLong ? green500 : null }}>
                        {this.state.eightCharactersLong && <i className="fa fa-check" style={{ fontSize: 12, color: green500, marginRight: 0 }} />} At least 8 characters
                    </div>
                    <div style={{ color: this.state.oneLowerCase ? green500 : null }}>
                        {this.state.oneLowerCase && <i className="fa fa-check" style={{ fontSize: 12, color: green500, marginRight: 0 }} />} One lower-case character
                    </div>
                    <div style={{ color: this.state.oneUpperCase ? green500 : null }}>
                        {this.state.oneUpperCase && <i className="fa fa-check" style={{ fontSize: 12, color: green500, marginRight: 0 }} />} One upper-case character
                    </div>
                    <div style={{ color: this.state.oneNumberOrSymbol ? green500 : null }}>
                        {this.state.oneNumberOrSymbol && <i className="fa fa-check" style={{ fontSize: 12, color: green500, marginRight: 0 }} />} One number or symbol character
                    </div>
                </div>
            </div>
        )
    }
}